<template>
  <div>
    <!-- Background -->
    <section class="material-half-bg">
      <div class="cover"></div>
    </section>

    <!-- Login Content -->
    <section class="login-content">
      <!-- Logo -->
      <div class="logo text-center">
        <img src="@/assets/logo-w.png" alt="Logo" style="max-width: 150px" />
        <h2 class="fw-bold mt-2 text-white">{{ appNameEn }}</h2>
        <h5 class="fw-bold text-white">{{ appName }}</h5>
      </div>

      <div class="login-box">
        <!-- LOGIN FORM -->
        <form class="login-form" @submit.prevent="handleLogin">
          <h3 class="login-head">
            <i class="bi bi-person me-2"></i>ลงชื่อเข้าใช้
          </h3>

          <div class="mb-3">
            <label class="form-label">USERNAME</label>
            <input
              type="text"
              class="form-control"
              placeholder="ชื่อผู้ใช้"
              v-model="loginForm.username"
              required
            />
          </div>

          <div class="mb-3">
            <label class="form-label">PASSWORD</label>
            <input
              type="password"
              class="form-control"
              placeholder="รหัสผ่าน"
              v-model="loginForm.password"
              required
            />
          </div>

          <div class="mb-3">
            <div class="utility d-flex justify-content-between">
              <div class="form-check">
                <label class="form-check-label">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="loginForm.rememberMe"
                  />
                  <span class="label-text">จำการเข้าสู่ระบบ</span>
                </label>
              </div>
              <p class="semibold-text mb-2">
                <a href="#" data-toggle="flip">ลืมรหัสผ่าน ?</a>
              </p>
            </div>
          </div>

          <div class="mb-3 btn-container d-grid">
            <button class="btn btn-primary btn-block" :disabled="isLoading">
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              <i class="bi bi-box-arrow-in-right me-2 fs-5"></i>เข้าสู่ระบบ
            </button>
          </div>
        </form>

        <!-- FORGOT PASSWORD FORM -->
        <form class="forget-form" @submit.prevent="resetPassword">
          <h3 class="login-head">
            <i class="bi bi-person-lock me-2"></i>ลืมรหัสผ่าน ?
          </h3>

          <div class="mb-3">
            <label class="form-label">EMAIL</label>
            <input
              class="form-control"
              type="email"
              placeholder="อีเมล"
              v-model="resetEmail"
            />
          </div>

          <div class="mb-3 btn-container d-grid">
            <button class="btn btn-primary btn-block">
              <i class="bi bi-unlock me-2 fs-5"></i>RESET
            </button>
          </div>

          <div class="mb-3 mt-3 text-center">
            <p class="semibold-text mb-0">
              <a href="#" data-toggle="flip">
                <i class="bi bi-chevron-left me-1"></i> กลับไปหน้าเข้าสู่ระบบ
              </a>
            </p>
          </div>
        </form>
      </div>

      <div class="text-center">
        <p class="mt-4 mb-2">
          © 2025 {{ appName }} | โรงพยาบาลวานรนิวาส จังหวัดสกลนคร
        </p>
        <p class="mb-4">พัฒนาโดย นายบัญชาชัย แพงพิมพ์โล้</p>
      </div>

    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  timer: 2000,
  showConfirmButton: false,
});

export default {
  name: "LoginPage",
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      appNameEn: process.env.VUE_APP_NAME_EN,
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        device_name: "aps",
      },
      resetEmail: "",
      isLoading: false,
    };
  },

  methods: {
    ...mapActions(["login"]),

    async handleLogin() {
      this.isLoading = true;
      try {
        await this.login(this.loginForm);

        Toast.fire({
          icon: "success",
          title: "เข้าสู่ระบบสำเร็จ",
        });

        this.$router.push("/");
      } catch (error) {
        console.error(error);

        const message =
          error.response?.data?.errors?.username?.[0] ||
          error.response?.data?.message ||
          "Login failed. Please check your credentials.";

        Toast.fire({ icon: "error", title: message });
      } finally {
        this.isLoading = false;
      }
    },

    resetPassword() {
      Toast.fire({
        icon: "info",
        title: "ระบบกำลังพัฒนา",
      });
    },
  },

  mounted() {
    // Flip login box (like original Vali Admin)
    const $ = window.jQuery;

    if ($) {
      $(".login-content [data-toggle='flip']").click(function () {
        $(".login-box").toggleClass("flipped");
        return false;
      });
    }
  },
};
</script>

<style scoped>
/* Keep Vali Admin styling from original template */
/* .material-half-bg .cover {
  background: #009688;
}
.login-content {
  margin-top: 50px;
}
.login-box {
  transition: transform 0.5s;
}
.login-box.flipped {
  transform: rotateY(180deg);
} */
</style>
